//Models
PJQ.models.projectContacts = {};

PJQ.models.projectContacts.ProjectContact = PJQ.models.contacts.Contact.extend({
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: this.get('projectId')
			},
			{
				endpoint: 'contacts',
				value: this.get('id')
			}
		])
	},
	parse: function (model) {
		PJQ.models.contacts.Contact.prototype.parseContactData.call(this, model);
		PJQ.models.contacts.Contact.prototype.parseAttachmentData.call(this, model);

		return model;
	},
	fetchProjectNotificationSettings: function (projectId, callback) {
		let notificationSettings = null;
		if (!this.isNew()) {
			notificationSettings = new PJQ.models.notificationSettings.ProjectNotificationSettings({
				id: this.get('id'),
				projectId: this.get('projectId')
			});
		} else {
			notificationSettings = new PJQ.models.notificationSettings.ProjectNotificationSettings({
				userTypeId: this.get('userTypeId')
			});
		}

		notificationSettings.fetch({
			success: _.bind(function () {
				callback(notificationSettings);
			}, this)
		});
	},
	updateIsPrimary: function (isPrimary, callback) {
		this.set('isPrimary', isPrimary);
		new PJQ.ajax.Request({
			endpoint: this.endpoint() + '?isPrimary=' + isPrimary.toString()
		}).patch().success(_.bind(function () {
			if (typeof callback === 'function') {
				callback(true);
			}
		}, this)).fail(_.bind(function () {
			if (typeof callback === 'function') {
				callback(false);
			}
		}, this));
	},
	beforeSave: function () {
		PJQ.models.contacts.Contact.prototype.beforeSave.call(this);
		this.set({
			attachments: this.attachments.getChangedModels()
		})
	}
});

//Collections
PJQ.collections.projectContacts = {};

PJQ.collections.projectContacts.ProjectContacts = PJQ.collections.BaseCollection.extend({
	idAttribute: 'id',
	model: PJQ.models.projectContacts.ProjectContact,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: this.options.project.id
			},
			{
				endpoint: 'contacts'
			}
		])
	},
	addContactsToProject: function (ids, callback) {
		new PJQ.ajax.Request({
			endpoint: this.endpoint() + '/ids',
			data: {
				ids: ids
			}
		}).post().success(_.bind(function (data) {
			this.reset(data);
			callback();
		}, this)).fail(_.bind(function (xhr) {
			//todo: toast error
			callback();
		}, this));
	}
});

//Views
PJQ.views.projectContacts = {};

PJQ.views.projectContacts.ProjectContactsManagement = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Project-Contacts-Management')
	},
	events: {
		'click .btn-edit-pc-perms': 'editPermissionsClicked',
		'click .btn-edit-pc-notification-settings': 'notificationSettingsClicked',
		'click .edit-project-contact': 'editClicked',
		'click .remove-project-contact': 'removeClicked',
		'click .project-contacts-new-contact': 'newContactClicked',
		'click .project-contacts-add-from-bid-participants': 'addFromBidParticipants',
		'click .project-contacts-add-from-address-book': 'addFromAddressBook',
		'click .project-contacts-quick-search': 'quickSearch',
		'click .project-contacts-add-from-project': 'addFromProject',
		'click .project-contacts-new-user': 'newUserClicked',
		'click .project-contacts-add-from-company': 'addFromCompany',
		'change .cb-primary': 'changeIsPrimary',
		'click .export-pdf': 'exportPDF',
		'click .export-excel': 'exportExcel',
		'click .btn-copy-email': 'copyEmail',
		'click .btn-copy-phone': 'copyPhone'
	},
	beforeFirstRender: function () {
		this.options.isAdmin = this.options.project.hasPermission('projectContacts.isAdmin');
		this.options.canEdit = PJQ.app.session.hasPermission('settings.canManageUsers');

		if (this.options.project.projectContacts != null) {
			this.collection = this.options.project.projectContacts;
		} else {
			this.collection = this.options.project.projectContacts = new PJQ.collections.projectContacts.ProjectContacts(null, {
				project: this.options.project
			});
		}

		PJQ.app.session.fetchUserGroups(this.options.project.get('masterUserId'), _.bind(function (grResult) {
			this.groups = grResult;

			this.listenTo(this.collection, 'reset update', _.bind(function () {
				this.renderDataTable();
			}, this));

			this.listenTo(this.collection, 'sync', _.bind(function () {
				this.dataTable.refresh('page');
			}, this));
			this.collection.fetchReset();
		}, this));
	},
	renderData: function () {
		return {
			canEdit: this.options.canEdit,
			isAdmin: this.options.isAdmin
		};
	},
	afterRender: function () {
		this.renderDataTable();
	},
	renderDataTable: function () {
		let columns = [
			{
				"title": "Type",
				"width": "120px",
				"orderable": true,
				"searchable": false,
				"render": _.bind(function (data, type, row) {
					if (row.userType != null) {
						if (type === 'sort') {
							return row.userType.get('sortOrder');
						}
						return '<span style="color:' + row.userType.get('color') + ';">' + row.userType.get('name') + '</span>';
					}
					return '';
				}, this)
			},
			{"data": "attributes.companyName", "title": "Company Name"},
			{"data": "attributes.contactName", "title": "Contact Name"},
			{
				"data": "attributes.email",
				"title": "Email",
				"orderable": true,
				"searchable": true,
				"render": function (data, type, row) {
					let maxEmailWidth = $(window).width() > 1200 ? 225 : 100;

					let html = '<div style="max-width:' + (maxEmailWidth != null ? (maxEmailWidth.toString() + 'px;') : 'auto') + '" class="d-flex align-items-center wd-100">',
						emailFormatted = (row.get('email') ? ('<a title="' + row.get('email') + '" style="color: inherit;" href="mailto:' + row.get('email') + '">' + row.get('email') + '</a>') : '');

					if (row.get('email') !== '')
						html += '<button type="button" class="btn btn-transparent-dark btn-copy-email" title="Copy Email" data-email="' + row.get('email') + '"><i class="far fa-envelope text-dark"></i></button>';

					html += '<div class="flex-fill of-hidden tof-ellipsis no-wrap' + (row.get('email') ? '' : 'text-muted') + '">' + emailFormatted + '</div></div>';
					return html;
					}
			},
			{
				"data": "attributes.phone",
				"title": "Phone",
				"orderable": true,
				"searchable": true,
				"render": _.bind(function (data, type, row) {
					let html = '<div style="min-width:100px;" class="d-flex align-items-center">',
						phoneWrapped = (row.get('phone') ? PJQ.helpers.formatHelpers.formatPhoneNumber(row.get('phone'), true) + (_.size(row.get('phoneExtension')) === 0 ? '' : ' x' + row.get('phoneExtension')) : 'N/A');

					html += '<div class="flex-fill ' + (row.get('phone') ? '' : 'text-muted') + '">' + phoneWrapped + '</div>';
					html += '</div>';
					return html;
				}, this)
			},
			{
				"data": "attributes.cell",
				"title": "Cell",
				"orderable": true,
				"searchable": true,
				"render": _.bind(function (data, type, row) {
					let html = '<div style="min-width:100px;" class="d-flex align-items-center">',
						phoneWrapped = (row.get('cell') ? PJQ.helpers.formatHelpers.formatPhoneNumber(row.get('cell'), true) : 'N/A');
					html += '<div class="flex-fill ' + (row.get('cell') ? '' : 'text-muted') + '">' + phoneWrapped + '</div>';
					html += '</div>';
					return html;
				}, this)
			},
			{
				"data": "attributes.projectGroups",
				"title": "Groups",
				"orderable": true,
				"searchable": true,
				"render": _.bind(function (data, type, row) {
					if (row.id > 0) {
						let arr = [];
						_.each(data, function (groupId) {
							let group = this.groups ? this.groups.get(groupId) : null;
							if (group != null) {
								arr.push(group);
							}
						}, this);
						return _.map(_.sortBy(arr, function (group) {
							return group.get('sortOrder');
						}), function (group) {
							return group.get('groupName');
						}).join(', ');
					}
					return '';
				}, this)
			}];

		if (PJQ.app.session.get('portalId') === 0 || PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_MANAGEMENT_CONTACTS_ENABLE_PRIMARY)) {
			columns.push({
				"data": "attributes.isPrimary",
				"title": "Primary",
				"width": "80px",
				"orderable": true,
				"searchable": false,
				"render": _.bind(function (data, type, row) {
					if (row.get('id') > 0) {
						return '';
					}

					if (type === 'sort') {
						return data;
					}
					return '<div class="pretty p-switch ml-3"><input type="checkbox" ' + (data ? 'checked' : '') + ' class="cb-primary" /><div class="state p-success"><label>&nbsp;</label></div></div>';
				}, this)
			});
		}
		columns.push(...[{
			"data": "",
			"title": "",
			"orderable": false,
			"searchable": false,
			"width": 120 + (this.options.isAdmin ? 40 : 0) + 'px',
			"render": _.bind(function (data, type, row) {
				let buttons = '',
					notificationButton = '<button type="button" title="Notifications" class="btn btn-purple btn-edit-pc-notification-settings mr-1"><span class="fal fa-bell"></span></button>';
				buttons += '<button type="button" title="Permissions" class="btn btn-dark btn-edit-pc-perms mr-1"><span class="fal fa-key"></span></button>';

				if (this.options.isAdmin) {
					buttons += (row.get('userId') === PJQ.app.session.user.get('userId') || PJQ.app.session.hasPermission('users.canModifyNotifications')) ? notificationButton : ``
				} else if (this.options.isAdmin) {
					buttons += notificationButton;
				}

				if (this.options.canEdit) {
					buttons += '<button type="button" title="Edit" class="btn btn-info edit-project-contact mr-1"><span class="fal fa-pencil"></span></button>';
				} else {
					buttons += '<button type="button" title="View" class="btn btn-info edit-project-contact mr-1"><span class="fal fa-search"></span></button>';
				}
				if (this.options.isAdmin) {
					buttons += '<button type="button" title="Remove" class="btn btn-danger remove-project-contact"><span class="fal fa-trash"></span></button>';
				}
				return '<div class="text-align-center show-on-row-hover" style="min-width: 140px">' + buttons + '</div>';
			}, this)
		}]);

		let self = this,
			tableOpts = {
				el: this.$('.project-contacts-data-table-container'),
				data: this.collection.models,
				pageLengthCookie: PJQ.constants.cookies.PROJECT_CONTACT_LIST_PAGE_LENGTH,
				language: {
					emptyTable: "No project contacts have been added to this project",
					zeroRecords: "No project contacts match the search criteria"
				},
				subTemplates: {
					header: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Data-Table-Header-Project-Contacts')
				},
				headerData: function () {
					return {
						userTypes: PJQ.app.session.userTypes.models,
						isAdmin: self.options.isAdmin
					};
				},
				initComplete: function (settings, json) {
					this.wrap("<div style='overflow:auto; width:100%;position:relative;'></div>");
				},
				afterHeaderRender: function (view, $header) {
					new PJQ.inputs.Selectpicker({
						el: $header.find('.user-type-filter'),
						onChange: function (value) {
							view.setFilter('userType', value);
						},
						isMultiple: true,
						isIntChoices: true,
						noneSelectedText: 'No Filters',
						defaultValue: self.userTypeFilter
					});
				},
				getFilterData: function (view, data) {
					let userTypeFilter = view.getFilter('userType');
					if (_.size(userTypeFilter) === 0) {
						return data;
					}

					return _.filter(data, function (row) {
						return _.contains(userTypeFilter, row.userType.id);
					});
				},
				onRowDoubleClick: _.bind(function (row) {
					if (row.data()) {
						this.editContact(row.data());
					}
				}, this),
				contextMenuOptions: {
					actions: [
						{
							name: 'Edit',
							iconClass: 'fal fa-pencil',
							isShown: _.bind(function (row) {
								return this.options.canEdit;
							}, this),
							onClick: _.bind(function (row) {
								this.editContact(row.data());
							}, this)
						},
						{
							name: 'View',
							iconClass: 'fal fa-search',
							isShown: _.bind(function (row) {
								return !this.options.canEdit;
							}, this),
							onClick: _.bind(function (row) {
								this.editContact(row.data());
							}, this)
						},
						{
							name: 'Manage Trades',
							iconClass: 'fal fa-hard-hat',
							onClick: _.bind(function (row) {
								new PJQ.views.projects.ManageProjectParticipantTradesModal({
									contactId: row.data().get('contactId'),
									onSave: _.bind(function (data) {
										row.data().set('projectGroups', _.map(_.filter(data.models, function (model) {
											return model.get('isSelected');
										}), function (model) {
											return {
												groupId: model.get('groupId')
											};
										}));
										row.invalidate().draw();
									}, this)
								});
							}, this),
							isShown: _.bind(function (row) {
								return PJQ.app.session.project.hasPermission('messaging.canManage') && this.options.view !== PJQ.constants.projectMessaging.views.MSGCONT_CONT && row.data().id > 0;
							}, this)

						},
						{
							name: 'Permissions',
							iconClass: 'fal fa-key',
							isShown: _.bind(function (row) {
								return this.options.isAdmin;
							}, this),
							onClick: _.bind(function (row) {
								this.editPermissions(row.data());
							}, this)
						},
						{
							name: 'Notifications',
							iconClass: 'fal fa-bell',
							isShown: _.bind(function (row) {
								return this.options.isAdmin && PJQ.app.session.hasPermission('users.canModifyNotifications');
							}, this),
							onClick: _.bind(function (row) {
								this.editNotificationsSettings(row.data());
							}, this)
						},
						{
							name: 'Remove',
							iconClass: 'fal fa-trash',
							isDanger: true,
							isShown: _.bind(function (row) {
								return this.options.isAdmin;
							}, this),
							onClick: _.bind(function (row) {
								this.removeContact(row);
							}, this)
						}
					]
				},
				columns: columns
			};
		this.dataTable = new PJQ.views.dataTables.DataTable(tableOpts);
	},
	copyEmail: function (e) {
		let target = $(e.currentTarget),
			projectContact = this.dataTable.getRow(target.closest('tr')).data();
		if (navigator && navigator.clipboard) {
			navigator.clipboard.writeText(projectContact.get('email'));
			PJQ.notifications.notify.successNotify({
				message: 'Email copied to clipboard'
			});
		}
	},
	copyPhone: function (e) {
	let inputId = 'h_input_' + _.uniqueId(),
		hiddenInput = $('<input>', {
			value: $(e.currentTarget).data('phone').replace(/ /g,''),
			style: 'position: absolute;left:-2000px;top:-2000px',
			id: inputId
		});
	this.$el.append(hiddenInput);
	hiddenInput[0].select();
	document.execCommand("copy");
	hiddenInput.remove();
	PJQ.notifications.notify.successNotify({
		message: 'Number copied to clipboard.'
	});
	},
	changeIsPrimary: function (e) {
		let target = $(e.currentTarget),
			isPrimary = target.prop('checked'),
			projectContact = this.dataTable.getRow(target.closest('tr')).data();
		if (projectContact != null) {
			projectContact.updateIsPrimary(isPrimary);
		}
	},
	editPermissionsClicked: function (e) {
		let target = $(e.currentTarget),
			projectContact = this.dataTable.getRow(target.closest('tr')).data();
		this.editPermissions(projectContact);
	},
	editPermissions: function (projectContact) {
		new PJQ.views.permissions.PermissionsEditorModal({
			model: projectContact,
			project: this.options.project
		});
	},
	notificationSettingsClicked: function (e) {
		let target = $(e.currentTarget),
			projectContact = this.dataTable.getRow(target.closest('tr')).data();
		this.editNotificationsSettings(projectContact);
	},
	editNotificationsSettings: function (projectContact) {
		new PJQ.views.notificationSettings.NotificationSettingsEditorModal({
			model: projectContact,
			project: this.options.project
		});
	},
	editClicked: function (e) {
		let target = $(e.currentTarget),
			projectContact = this.dataTable.getRow(target.closest('tr')).data();
		this.editContact(projectContact);
	},
	editContact: function (projectContact) {
		new PJQ.views.contacts.BaseEditContactModal({
			model: projectContact
		});
	},
	removeClicked: function (e) {
		let target = $(e.currentTarget),
			row = this.dataTable.getRow(target.closest('tr'));
		this.removeContact(row);
	},
	removeContact: function (row) {
		let projectContact = row.data();
		new PJQ.views.modals.DeleteCancel({
			header: "Confirm Remove",
			deleteButtonText: "Remove",
			body: "Are you sure you want to remove this contact from the project?",
			onDelete: _.bind(function () {
				this.collection.remove(projectContact);
				projectContact.destroy();
			}, this)
		});
	},
	addFromBidParticipants: function () {
		this.options.project.fetchParticipants(_.bind(function (participants) {
			new PJQ.views.contacts.SelectContactsModal({
				contacts: participants,
				hideContacts: this.collection.models,
				context: PJQ.constants.contacts.contexts.PARTICIPANTS,
				isSingleChoice: false,
				subtitle: "Add Project Contacts from Bid Participants",
				onSave: _.bind(function (selectedContacts) {
					this.collection.addContactsToProject(_.map(selectedContacts, function (contact) {
						return contact.id;
					}), _.bind(function () {
						this.renderDataTable();
					}, this));
				}, this)
			});
		}, this));
	},
	addFromAddressBook: function () {
		$('form[name="modal-add-participants"]').remove();
		let options = {
			onSave: _.bind(function (selectedContactsAll, data) {
				this.collection.addContactsToProject(selectedContactsAll, _.bind(function () {
					this.renderDataTable();
				}, this));
			}, this),
			disableContacts: _.map(this.collection.models, function (contact) {
				return contact.id;
			})
		};

		if (!PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_NEW_ADDRESSBOOK)) {
			options.isWrapForm = false;
			options.wrapFormName = null;
			options.isUseNewAddressBook = true;
			options.isMultipleProjects = true;
		}

		new PJQ.views.projects.AddParticipantsDetailedModal(options);
	},
	quickSearch: function () {
		new PJQ.views.contacts.SelectContactsModal({
			context: PJQ.constants.contacts.contexts.CONTACTS,
			isSingleChoice: false,
			project: this.options.project,
			subtitle: "Add Project Contacts From Address Book",
			onSave: _.bind(function (selectedContacts) {
				this.collection.addContactsToProject(_.map(selectedContacts, function (contact) {
					return contact.id;
				}), _.bind(function () {
					this.renderDataTable();
				}, this));
			}, this)
		});
	},
	addFromProject: function () {

	},
	addFromCompany: function () {
		new PJQ.views.contacts.SelectContactsModal({
			context: PJQ.constants.contacts.contexts.USERS,
			isSingleChoice: false,
			hideContacts: this.collection.models,
			subtitle: "Add Project Contacts from My Company Users",
			onSave: _.bind(function (selectedContacts) {
				this.collection.addContactsToProject(_.map(selectedContacts, function (contact) {
					return -contact.id;
				}), _.bind(function () {
					this.renderDataTable();
				}, this));
			}, this)
		});
	},
	newContactClicked: function () {
		new PJQ.views.contacts.BaseEditContactModal({
			model: new PJQ.models.projectContacts.ProjectContact({
				projectId: PJQ.app.session.project.id,
				country: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_DEFAULT_COUNTRY) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_DEFAULT_COUNTRY) : 'US'
			})
		});
	},
	newUserClicked: function () {
		new PJQ.views.contacts.BaseEditContactModal({
			model: new PJQ.models.projectContacts.ProjectContact({
				projectId: PJQ.app.session.project.id
			})
		});
	},
	exportProjectContacts: function () {
		new PJQ.ajax.Request({
			endpoint: this.options.project.endpoint(false) + '/contacts/export',
			data: {
				isApi2: true
			}
		}).post().done(_.bind(function (response) {
			PJQ.files.downloadFile(response.url, {
				isEndpoint: false
			});
		}, this)).fail(_.bind(function (xhr, err, result) {
		}, this));
	},
	exportExcel: function () {
		if (this.options.project == null) {
			return;
		}

		let filters = {},
			userTypeFilter = this.dataTable.getFilter('userType');

		if (_.size(userTypeFilter) > 0) {
			filters.userTypes = userTypeFilter;
		}

		let order = this.dataTable.dataTable.order()[0],
			report = new PJQ.models.reports.NewReport({
				type: "projectContacts",
				projectId: this.options.project.id,
				options: {
					filters: filters,
					columns: ["userType", "companyName", "contactName", "email", "phone", "cell", "trades"],
					columnOrder: order
				}
			});
		report.export({format: 'excel'}).then(() => {

		});
	},
	exportPDF: function () {
		if (this.options.project == null) {
			return;
		}

		let filters = {},
			userTypeFilter = this.dataTable.getFilter('userType');

		if (_.size(userTypeFilter) > 0) {
			filters.userTypes = userTypeFilter;
		}

		let order = this.dataTable.dataTable.order()[0],
			report = new PJQ.models.reports.NewReport({
				type: "projectContacts",
				projectId: this.options.project.id,
				options: {
					filters: filters,
					columns: ["userType", "companyName", "contactName", "email", "phone", "cell", "trades"],
					columnOrder: order
				}
			});
		report.export({format: 'pdf'}).then(() => {

		});
	}
});

//Routes
PJQ.modules.projectContacts = {
	routes: [
		{
			route: 'projects/:projectId/contacts',
			name: 'projectContacts',
			callback: function (projectId) {
				PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "projectcontacts");
			}
		},
		{
			route: 'projects/:projectId/contacts/:id',
			name: 'projectContact',
			callback: function (projectId, id) {
				PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "projectcontacts", {
					id: id
				});
			}
		}
	]
};

PJQ.app.addRoutes(PJQ.modules.projectContacts.routes);